import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { getTrans as t } from "../../../Localization/translations";
import { useNavigate } from "react-router-dom";
import PartyRoleList from "./PartyRoleList";
import { useForm } from "react-hook-form";
import AsyncSelect from "react-select/async";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useRef } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { ArrowRight, Plus, Save, Search } from "lucide-react";
import AddPartyService from "../../../services/party/addparty.service";
import AddPartyAddressService from "../../../services/party/address/addAddress.service";
import AddCutomer from "../Customer/addCutomer";


const AddPartyRole = ({ contract_id, contract_type, tabindex, party_id }) => {
    const [formData, setFormData] = useState({
        party: "",
        role: "",
        contract: contract_id,
        comment: ""
    });

    const {
        register,
        handleSubmit,
        clearErrors,
        reset,
        trigger,
        formState: { errors },
    } = useForm();
    const navigate = useNavigate();
    const form = useRef();
    const checkBtn = useRef();

    const [selectedValue, setSelectedValue] = useState(null);
    const [inputvalue, setValue] = useState("");
    const [options, setOptions] = useState([]);

    const [role, setRole] = useState("");
    const [rolesList, setRolesList] = useState([]); // New state for dynamic roles

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const [hideshow, setHideShow] = useState(false)

    // SIDE PANEL STATE (same as createLease)
    const [state1, setState1] = useState({
        isPaneOpen: false,
        isPaneOpenLeft: false,
    });

    // FORM 2 (customer form inside panel)
    const form2 = useRef();
    const checkBtn2 = useRef();

    const {
        register: register2,
        handleSubmit: handleSubmit2,
        reset: reset2,
        formState: { errors: errors2 },
    } = useForm();


    const [party_type, setParty_type] = useState("Customer");
    const [customer_type, setCustomer_type] = useState("Organization");
    const [customer_name, setCustomer_name] = useState("");
    const [address_line_1, setAddress_line_1] = useState("");
    const [address_line_2, setAddress_line_2] = useState("");
    const [city, setCity] = useState("");
    const [zip_code, setZip_code] = useState("");
    const [countryid, setCountryid] = useState("");
    const [country_name, setCountry_name] = useState([]);
    const [stateaddressId, setStateAddressId] = useState("");
    const [state_name, setState_name] = useState([]);


    const handleshowhide = (e) => {
        setCustomer_type(e.target.value);
    };

    const handlecountry = (e) => {
        const value = e.target.value;
        setCountryid(value);
        getstate(value);   // 🔥 important
    };

    const handlestate = (e) => {
        setStateAddressId(e.target.value);
    };

    useEffect(() => {
        getcountry();
    }, []);

    const getcountry = async () => {
        try {
            const res = await fetch(API + "helper/ajax/load-countries/");
            const data = await res.json();
            setCountry_name(data);
        } catch (err) {
            console.error(err);
            toast.error("Failed to load countries");
        }
    };

    const getstate = async (id) => {
        try {
            if (id) {
                const res = await fetch(API + "helper/ajax/load-states/" + id + "/");
                const data = await res.json();
                setState_name(data);
            }
        } catch (err) {
            console.error(err);
            toast.error("Failed to load states");
        }
    };

    const handleparty = () => {
        form2.current.validateAll();

        if (checkBtn2.current.context._errors.length === 0) {

            AddPartyService.addParty(customer_type, party_type, customer_name)
                .then((response) => {
                    if (response.data.success) {

                        const partyId = response.data.partyId;

                        // Add Address
                        AddPartyAddressService.addPartyAddress(
                            partyId,
                            address_line_1,
                            address_line_2,
                            city,
                            stateaddressId,
                            zip_code,
                            countryid,
                            "Yes",
                            "No",
                            "Yes"
                        );

                        toast.success("Customer added successfully");

                        // auto select in dropdown
                        setSelectedValue(partyId);
                        reset({ selectedValue: partyId });

                        // close panel
                        setState1({ isPaneOpen: false });

                        // refresh dropdown
                        loadInitialOptions();

                        // reset form
                        setCustomer_name("");
                        setAddress_line_1("");
                        setCity("");
                        setZip_code("");

                    } else {
                        toast.error(response.data.error);
                    }
                });
        }
    };

    const handlepartydefault = () => {
        handleparty();
    };

    // Fetch roles from company settings
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await axios.get(`${API}company/companysettingsview/`, { headers: authHeader() });
                if (response.data.party_roles) {
                    const roles = response.data.party_roles.split(',').map(r => r.trim());
                    setRolesList(roles);
                }
            } catch (error) {
                console.error("Error fetching company settings:", error);
                toast.error("Failed to load party roles");
            }
        };
        fetchRoles();
        loadInitialOptions();
    }, []);

    const handleRegister = (e) => {
        form.current.validateAll();

        if (checkBtn.current.context._errors.length === 0) {

            formData.party = selectedValue
            formData.role = role

            axios
                .post(`${API}contracts/party-roles/create/`, formData, { headers: authHeader() })
                .then((response) => {
                    if (response.data.success === 1) {
                        toast.success("Additional Parties added successfully", {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "light",
                        });
                        setTimeout(() => {
                            setHideShow(true); // Navigate back to the list
                        }, 1000);
                    } else {
                        toast.error(response.data.error || "Failed to add Additional Parties", {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: false,
                            pauseOnHover: true,
                            draggable: true,
                            theme: "light",
                        });
                    }
                })
                .catch((error) => {
                    toast.error("Error adding Additional Parties", {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        pauseOnHover: true,
                        draggable: true,
                        theme: "light",
                    });
                });
        }
    };

    const handleCancel = () => {
        setHideShow(true)
    }

    const handelInputChange = (value) => {
        setValue(value);
    };

    const handelChange = (value) => {
        if (value === null) {
            setSelectedValue(value);
            reset({
                selectedValue: value,
            });

        } else {
            setSelectedValue(value.id);
            reset({
                selectedValue: value.id,
            });

        }
        trigger("selectedValue");

    };

    const loadOptions = async (inputValue) => {
        if (inputValue !== "") {
            const responseJSON = await axios.get(
                API +
                `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
                { headers: authHeader() }
            );
            return responseJSON.data.data;
        }
    };

    const loadInitialOptions = async () => {
        const responseJSON = await axios.get(
            API +
            `parties/vendor/?party_type=Customer&&customer_name=`,
            { headers: authHeader() }
        );
        setOptions(responseJSON.data.data);
    };

    useEffect(() => {

        loadInitialOptions();

    }, []);

    return (
        <>
            <ToastContainer />
            <AddCutomer
                state1={state1}
                setState1={setState1}
                handleSubmit2={handleSubmit2}
                handlepartydefault={handlepartydefault}
                form2={form2}
                party_type={party_type}
                setParty_type={setParty_type}
                customer_type={customer_type}
                register2={register2}
                handleshowhide={handleshowhide}
                errors2={errors2}
                customer_name={customer_name}
                setCustomer_name={setCustomer_name}
                address_line_1={address_line_1}
                setAddress_line_1={setAddress_line_1}
                countryid={countryid}
                country_name={country_name}
                handlecountry={handlecountry}
                stateaddressId={stateaddressId}
                state_name={state_name}
                handlestate={handlestate}
                city={city}
                setCity={setCity}
                zip_code={zip_code}
                setZip_code={setZip_code}
                checkBtn2={checkBtn2}
                setAddress_line_2={setAddress_line_2}
                address_line_2={address_line_2}
            />
            {
                hideshow === true ?
                    <PartyRoleList id={contract_id} contracttype={contract_type} setTab={tabindex} party_id={party_id} />
                    :
                    <div className="  row py-2">
                        <div className=" col-md-12">
                            <div className="header pb-0 mb-2 ">
                                <h5 className="mb-0">{t("Add Party Role")}</h5>
                            </div>
                            <div className="card">
                                <div className=" card-body">
                                    <Form ref={form} action="."
                                        method="POST" onSubmit={handleSubmit(handleRegister)}>
                                        <div className="row">
                                            <div className="col-md-6 mt-2">
                                                <div className="col-lg-12">
                                                    <label className="col-form-label required">
                                                        {t("Party")}{" "}
                                                        <Tooltip content={t("Party_Tooltip")}>
                                                            <i className="fa fa-light fa-circle-info"></i>
                                                        </Tooltip>
                                                    </label>
                                                    <AsyncSelect
                                                        {...register("selectedValue", {
                                                            required: "Customer is required",
                                                        })}
                                                        defaultOptions={options}
                                                        isClearable
                                                        placeholder={t("Search for Party(%for All)")}
                                                        options={options}
                                                        value={options.find(
                                                            (option) => option.id === selectedValue
                                                        )}
                                                        getOptionLabel={(e) => e.customer_name}
                                                        getOptionValue={(e) => e.customer_name}
                                                        loadOptions={loadOptions}
                                                        onInputChange={handelInputChange}
                                                        onChange={handelChange}
                                                        name="selectedValue"
                                                    ></AsyncSelect>
                                                    <div className="invalid-feedback">
                                                        {errors.selectedValue && errors.selectedValue.message}
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn-link add-new-link"
                                                        onClick={() => setState1({ isPaneOpen: true })}
                                                    >
                                                        <Plus className="btn-icon-small" />
                                                        Add New Customer
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className="form-group">
                                                    <label className="col-form-label required">
                                                        {t("Role")}{" "}
                                                        <Tooltip content={t("Role_Tooltip")}>
                                                            <i className="fa fa-light fa-circle-info"></i>
                                                        </Tooltip>
                                                    </label>
                                                    <select
                                                        onChange={(e) => setRole(e.target.value)}
                                                        id="role"
                                                        className="form-control"
                                                        value={role}
                                                    >
                                                        <option value="">{t("Select")}</option>
                                                        {rolesList.map((r) => (
                                                            <option key={r} value={r}>
                                                                {t(r)}
                                                            </option>
                                                        ))}
                                                        {/* <option value="GUARANTOR">{t("Guarantor")}</option>
                                            <option  value="INSURANCE_PROVIDER">{t("Insurance Provider")}</option>
                                            <option  value="PRIVATE_LABEL_HOLDER">{t("Private Label Holder")}</option> */}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mt-2">
                                                <div className="form-group">
                                                    <label className="col-form-label">
                                                        {t("Comment")}
                                                    </label>
                                                    <textarea
                                                        className="form-control"
                                                        name="comment"
                                                        value={formData.comment}
                                                        onChange={handleChange}
                                                        placeholder="Enter comment"
                                                        rows={3}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="ms-auto my-auto mt-3">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary mb-0"
                                                        onClick={() => handleCancel()}
                                                        style={{ marginRight: "10px" }}
                                                    >
                                                        {t("Cancel")}
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary mb-0"
                                                    >
                                                        {t("Save")}
                                                    </button>
                                                    <CheckButton style={{ display: "none" }} ref={checkBtn} />

                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    );
};

export default AddPartyRole;